import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import ConsoleComponent from '../Components/DataService/ConsoleComponent';

function DataServiceConsolePage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <ConsoleComponent />
    </div>
  );
}

export default DataServiceConsolePage;


